import { render, staticRenderFns } from "./ConfirmDeparture.vue?vue&type=template&id=fcd9818c&scoped=true&"
import script from "./ConfirmDeparture.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeparture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd9818c",
  null
  
)

export default component.exports